export const HOME_PAGE = 'home-page';
export const LOBBY_PAGE = 'lobby-page';
export const SLOTS_PAGE = 'slots-page';
export const BLACKJACK_PAGE = 'blackjack-page';
export const ROULETTE_PAGE = 'roulette-page';
export const JACKPOTS_PAGE = 'jackpots-page';
export const CASINO_GAMES_PAGE = 'casino-games-page';
export const PROGRESSIVE_VIDEO_SLOTS_PAGE = 'progressive-video-slots-page';
export const NEW_GAMES_PAGE = 'new-games-page';
export const GAMING_HISTORY_PAGE = 'gaming-history-page';
export const TIPPING_HISTORY_PAGE = 'tipping-history-page';
export const SESSION_HISTORY_PAGE = 'session-history-page';
export const CHALLENGE_PAGE = 'challenge-page';
export const LIVE_CASINO_PAGE = 'live-casino-page';
export const VIDEO_POKER_PAGE = 'video-poker-page';
export const SCRATCH_CARDS_PAGE = 'scratch-cards-page';
export const EXCLUSIVE_888_GAMES_PAGE = '888-exclusive-games';
export const NEW_LIVE_CASINO_PAGE = 'live-casino-new-page';
export const INSTANT_WIN_GAMES_PAGE = 'instant-win-games-page';
export const VIRTUAL_SPORTS_PAGE = 'virtual-sports-page';

export const ORBIT_TAP = 'orbit-tap';
export const CGP_GAME_OPEN = 'cgp-game-open';
export const JACKPOTS_ITEM = 'jackpots-item';
export const LIVE_CASINO_ITEM = 'live-casino-item';

export const LIVE_STREAMING_ITEM = 'live-streaming-item';
export const STATIC_VIDEO_ITEM = 'static-video-item';

export const EXCLUSIVES_LIST_ICON = 'exclusives-list-icon';

export const MOVE_TOP = 'move-top';
export const STICKY = 'sticky';
export const CGP_OVERLAY_OPEN = 'cgp-overlay-open';
export const EMBEDDED_HYBRID  = 'cgp-embedded-hybrid';
export const MODAL_DIALOG = 'modal-dialog';
export const MAIN_SCREEN = 'main-screen';
export const MINI_ORBIT  = 'mini-orbit';
export const USER_MENU_OPEN  = 'user-menu-open';
export const ACTIVE = 'active';
export const LIVE_CASINO_PAGE_WRAPPER = 'live-casino-page-wrapper';
export const OPEN_MENU = 'open-menu';
export const DRAGGING = 'dragging';
export const SDK_CSS_OVERRIDE = 'sdk-css-override';